import { useLocation } from 'react-router-dom'

import { LegalDocumentPage } from '@/components/legal/legal-document-page'

export function LegalRoutes() {
  const { pathname } = useLocation()

  if (pathname === '/legal/privacy') {
    return <LegalDocumentPage documentId="privacy" />
  }
  if (pathname === '/legal/terms') {
    return <LegalDocumentPage documentId="terms" />
  }

  return null
}
